/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RDSInstances { 
    instance_arn: string;
    instance_clusterEP: string;
    instance_identifier: string;
    instance_name: string;
    instance_status: string;
    engine?: string;
    engine_version?: string;
}

